import { useRouteQuery } from '@/common/route/useRouteQuery';
import { pageSize } from '@/common/utils/helpers';
import { useBaseListView } from '@/common/view/useBaseListView';
import { useCrudActions } from '@/common/view/useCrudActions';
import { PromotionBoosterLinkableType, useMixins } from '@/modules/promotion/booster/model/mixins';
import { promotionService } from '@/services/promotion';

export function usePromotionBoosterList() {
    const { fetchLinkableItems, getItemLink, getItemName } = useMixins();

    const { query, updateQueryToRoute } = useRouteQuery({
        definition: {
            offset: { type: 'number', default: 0 },
            limit: { type: 'number', default: pageSize }
        },
        onChange: () => fetchList()
    });

    const { list, total, fetchList } = useBaseListView({
        request: promotionService.booster.list,
        paramsBuilder: () => ({ ...query }),
        hooks: {
            loadInitialData: async () => await fetchLinkableItems(),
            onPageChange: offset => (query.offset = offset),
            onSuccess: updateQueryToRoute,
            transformResponse: (list: any[]) =>
                list.map(promotionBooster => ({
                    ...promotionBooster,
                    linkedItemName: getItemName(
                        PromotionBoosterLinkableType.PromotionItem,
                        promotionBooster.promotionId
                    ),
                    linkedItemLink: getItemLink(
                        PromotionBoosterLinkableType.PromotionItem,
                        promotionBooster.promotionId
                    )
                }))
        }
    });

    const actions = {
        remove: useCrudActions().confirmAndRemove({
            request: promotionService.booster.remove,
            onSuccess: () => fetchList()
        })
    };

    return { list, total, query, fetchList, actions };
}
